import { IconTimelineItem } from 'Icons';
import { Button } from 'Elements';
import styles from 'partials/timeline.module.scss';

export const TimelineSingleItem = ({ fill, onClick }) => {
	return (
		<Button className={styles.item} onClick={onClick}>
			<IconTimelineItem className={styles.itemIcon} fill={fill} />
		</Button>
	);
};
